export const useCustomTableFilters = hooks => {
  hooks.stateReducers.push(reducer);
};

useCustomTableFilters.pluginName = "useCustomTableFilters";

function reducer(state, action, previousState, instance) {
  const {
    pushNotification,
    defaultFilters,
    unclearableFilters,
  } = instance;
  if (action.type === "setAllFilters") {
    if (action.filters === defaultFilters) {
      pushNotification?.({
        key: "table-filters",
        type: "info",
        title: "Table filters",
        message: "Default filters for the page have been set",
      });
    }
  }

  if (unclearableFilters?.length) {
    if (action.type === "setAllFilters") {

      let somethingWasRestored = false;

      const newFilters = [ ...action.filters ];
      for (const filter of newFilters) {
        if (filter.value === null || filter.value === undefined) {
          const unclerableFilter = unclearableFilters.find(x => x.id === filter.id);
          if (unclerableFilter) {
            somethingWasRestored = true;
            filter.value = unclerableFilter.value;
          }
        }
      }
      for (const filter of unclearableFilters) {
        if (!newFilters.some(x => x.id === filter.id)) {
          somethingWasRestored = true;
          newFilters.push(filter);
        }
      }

      if (somethingWasRestored) {
        pushNotification?.({
          key: "table-filters",
          type: "info",
          title: "Table filters",
          message: "Some filters can't be empty and they were restored to defaults",
        });
      }

      return {
        ...state,
        filters: newFilters,
      };
    } else if (action.type === "setFilter") {
      const {
        columnId,
        filterValue,
      } = action;

      if (filterValue === null || filterValue === undefined) {
        const unclearableFilter = unclearableFilters.find(x => x.id === columnId);
        if (unclearableFilter) {
          const column = instance.allColumns.find(x => x.id === columnId);

          pushNotification?.({
            key: "table-filters",
            type: "info",
            title: "Table filters",
            message: <>{column.Header} filter can't be empty and was restored to default</>,
          });

          return {
            ...state,
            filters: [
              ...state.filters.filter(x => x.id !== columnId),
              unclearableFilter,
            ],
          };
        }
      }
    }
  }

  return state;
}
